export default __webpack_public_path__ + "static/media/icon-reorder.99c9103e.svg";